import baseURLv1 from '@/services/APIConfig';
import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    faqSections: [],
    filters: {
      search: '',
    },
  },
  mutations: {
    set,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
    },
  },
  actions: {
    async load({ state, commit }, payload) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/faq/enabled/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['faqSections', response.data.data]);
      commit('set', ['isLoading', false]);
    },
  },
  getters: {
    ifEmpty: (state) => {
      return state.faqSections.length === 0 || state.faqSections.every((section) => section.queries.length === 0);
    },
  },
};
